import React from 'react';
import contractTypes from 'providers/staticContractTypes';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import classes from './CoworkerDetails.module.scss';

const CoworkerContractType = ({ title, data }: { title: string; data: string; }) => {
    const { t } = useTranslation();
    const contractType = contractTypes.get(data) || t('N/A');

    return (
        <div className={classes.value}>
            <Text textStyle="Heading.XS" data-testid="contract-type-label">
                {t(title)}
            </Text>
            <Text textStyle="Body.M" data-testid="contract-type-value">
                {t(contractType)}
            </Text>
        </div>
    );
};

export default CoworkerContractType;
